import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { UserRole } from '@ess-front/shared';
import { AuthDomainService } from '@app/auth/domain/auth-domain.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  private readonly MEMBERS_AREA_URL = '/members-area';
  private readonly STAFF_AREA_URL = '/staff-area';

  constructor(
    private authDomainService: AuthDomainService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.authDomainService.isAuthenticatedInStorage()) {
      const role = this.authDomainService.getStorageAuthData()?.role;
      if (role) {
        const redirectUrl = role === UserRole.STAFF ? this.STAFF_AREA_URL : this.MEMBERS_AREA_URL;
        this.router.navigateByUrl(redirectUrl);
      }
      return false;
    } else {
      return true;
    }
  }
}
